var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5711 1.61775C16.6069 0.581922 18.0118 0 19.4767 0C20.9415 0 22.3464 0.581921 23.3823 1.61775C24.4181 2.65357 25 4.05846 25 5.52333C25 6.98821 24.4181 8.39309 23.3823 9.42892L8.23374 24.5774C7.96317 24.848 7.59621 25 7.21358 25H1.44272C0.645926 25 0 24.3541 0 23.5573V17.7864C0 17.4038 0.152 17.0368 0.422562 16.7663L15.5711 1.61775ZM19.4767 2.88543C18.7771 2.88543 18.1061 3.16335 17.6114 3.65806L2.88543 18.384V22.1146H6.61599L21.3419 7.38861C21.8366 6.89391 22.1146 6.22295 22.1146 5.52333C22.1146 4.82372 21.8366 4.15276 21.3419 3.65806C20.8472 3.16335 20.1763 2.88543 19.4767 2.88543Z",
    fill: "url(#paint0_linear_3149_1279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1284 3.06047C14.6918 2.49705 15.6053 2.49705 16.1687 3.06047L21.9395 8.83133C22.503 9.39475 22.503 10.3082 21.9395 10.8716C21.3761 11.4351 20.4626 11.4351 19.8992 10.8716L14.1284 5.10078C13.5649 4.53736 13.5649 3.62388 14.1284 3.06047Z",
    fill: "url(#paint1_linear_3149_1279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3149_1279",
    x1: 0.378788,
    y1: 4.51128,
    x2: 25.7316,
    y2: 5.46058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5FAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3149_1279",
    x1: 0.378788,
    y1: 4.51128,
    x2: 25.7316,
    y2: 5.46058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5FAB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.c6b33c9ad80493a134c1940a4bb8fc7d.svg";
export { ForwardRef as ReactComponent };